const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white p-4 mt-auto"> {/* Charcoal Black */}
      <div className="container mx-auto text-center">
        &copy; 2025 P2F2. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;